export default {
  namespaced: true,
  state () {
    return {
      version: '0.1.61',
      loading: false,
      error: null,
      param: null,
      debug: false,
      privilege: 'owner',
      goal: true,
      windowSize: {},
      school: null,
      init: false,
      maintenance: null,
      preschool: false,
      extension: null
    }
  },
  getters: {
    version (state) {
      return state.version
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    param (state) {
      return state.param
    },
    debug (state) {
      return state.debug
    },
    privilege (state) {
      return state.privilege
    },
    goal (state) {
      return state.goal
    },
    windowSize (state) {
      return state.windowSize
    },
    school (state) {
      return state.school
    },
    maintenance (state) {
      return state.maintenance
    },
    preschool (state) {
      return state.preschool
    },
    extension (state) {
      return state.extension
    }
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setParam (state, payload) {
      state.param = payload
    },
    setDebug (state, payload) {
      state.debug = payload
    },
    setPrivilege (state, payload) {
      state.privilege = payload
    },
    setGoal (state, payload) {
      state.goal = payload
    },
    setWindowSize (state, payload) {
      state.windowSize = payload
    },
    setSchool (state, payload) {
      state.school = payload
    },
    setMaintenance (state, payload) {
      state.maintenance = payload
    },
    setPreschool (state, payload) {
      state.preschool = payload
    },
    setExtension (state, payload) {
      state.extension = payload
    }
  },
  actions: {
    setLoading ({ commit }, payload) {
      commit('setLoading', payload)
    },
    setError ({ commit }, payload) {
      commit('setError', payload)
    },
    setParam ({ commit }, payload) {
      commit('setParam', payload)
    },
    setDebug ({ commit }, payload) {
      commit('setDebug', payload)
    },
    setPrivilege ({ commit }, payload) {
      commit('setPrivilege', payload)
    },
    setGoal ({ commit }, payload) {
      commit('setGoal', payload)
    },
    setWindowSize ({ commit }, payload) {
      commit('setWindowSize', payload)
    },
    setSchool ({ commit }, payload) {
      return new Promise((resolve) => {
        commit('setSchool', payload)
        resolve()
      })
    },
    setMaintenance ({ commit }, payload) {
      commit('setMaintenance', payload)
    },
    setPreschool ({ commit }, payload) {
      commit('setPreschool', payload)
    },
    setExtension ({ commit }, payload) {
      commit('setExtension', payload)
    }
  }
}
